import { ReactComponent as BestPhotoIcon } from 'img/quota-landing/aiTariff/stars_20.svg';
import React, { type ReactElement, memo } from 'react';
import { Hint } from 'reactApp/ui/Hint/Hint';

import styles from '../new/DataListItemThumb.css';

export const BestPhoto = memo((): ReactElement => {
    return (
        <Hint text="Лучшее фото">
            <div className={styles.bestPhoto} data-qa-id="duplicates-group-best-photo">
                <BestPhotoIcon />
            </div>
        </Hint>
    );
});
BestPhoto.displayName = 'BestPhoto';
